export enum MapViewContextMenuItem {
  land = 'LAND',
  building = 'BUILDING',
  cases = 'CASES',
}
